
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/advancedStylePanel/templates/coverImage/coverImage.scss.css.virtualfile';
        module.exports = {"mediaAddPosterIndicator":"_mediaAddPosterIndicator_1qu04_7","st1":"_st1_1qu04_14","st2":"_st2_1qu04_16","st3":"_st3_1qu04_18"};